import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-metrics-settings',
  templateUrl: './metrics-settings.component.html',
  styleUrls: ['./metrics-settings.component.scss']
})
export class MetricsSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
